export default "__VITE_ASSET__7202f0eb__"